// custom-actions.service.ts
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "@alfresco/adf-core";
import { algAuthorizationHeader } from '../src/lib/alg-auth';

@Injectable({
  providedIn: 'root'
})
export class EditTextService {

  constructor(
    private http: HttpClient,
    private authService: AuthenticationService) {
  }

  editText(note: any, data: any) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${data.id}/content?majorVersion=false&name=${data.name}&include=allowableOperations`;
    let auth = algAuthorizationHeader(this.authService);
    // @ts-ignore
    let headers = new HttpHeaders().append('Authorization', auth).append('Content-Type', 'text/plain');
    return this.http.put(endpointUrl, note, {headers: headers});
  }

  getTxtFileContent(nodeId: string) {
    const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/nodes/${nodeId}/content`;
    let auth = algAuthorizationHeader(this.authService);

    let headers = new HttpHeaders()
      .append('Authorization', auth)
      .append('Content-Type', 'text/plain');

    // Effectuer la requête GET pour obtenir le contenu du fichier texte
    return this.http.get(endpointUrl, { headers, responseType: 'text' });
  }
}
